/**
 * Generic sorting functon
 * @param {array} data - The array of data to be sorted
 * @param {string} sortParam - The parameter to sort the data by
 * @param {string} sortOrder - The order to sort by A -> Z or Z -> A
 * @returns {array} - The sorted data
 */

// TO DO: If data starts coming in with a mix of strings and numbers, this will need to be updated to ensure that it sorts correctly
export default function sort(data, sortParam, sortOrder) {
  let sortedData;

  if (sortOrder === 'az') {
    sortedData = data.sort(function (a, b) {
      let aParam = a[sortParam];
      let bParam = b[sortParam];
      if (typeof aParam === 'string') {
        aParam = aParam.toUpperCase(); // ignore upper and lowercase
      }
      if (typeof bParam === 'string') {
        bParam = bParam.toUpperCase(); // ignore upper and lowercase
      }

      if (aParam < bParam) {
        return -1;
      }
      if (aParam > bParam) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  } else if (sortOrder === 'za') {
    sortedData = data.sort(function (a, b) {
      let aParam = a[sortParam];
      let bParam = b[sortParam];
      if (typeof aParam === 'string') {
        aParam = aParam.toUpperCase(); // ignore upper and lowercase
      }
      if (typeof bParam === 'string') {
        bParam = bParam.toUpperCase(); // ignore upper and lowercase
      }
      if (aParam < bParam) {
        return 1;
      }
      if (aParam > bParam) {
        return -1;
      }
      // names must be equal
      return 0;
    });
  }
  return sortedData;
}
